/** The tab bar type. */
export enum TabBarType {
  /** Standard tabs */
  Tabs,

  /** Simpler switch appearance */
  Switch,

  /** Vertical tabs */
  Vertical,
}
